<template>
  <b-form-group
    v-if="filter.type.toLowerCase() == 'select'"
    :label="filter.label"
    :label-for="filter.id"
  >
    <v-select
      :input-id="filter.id"
      :options="filter.options"
      
      placeholder="กรุณาเลือกข้อมูล"
      @input="setSelected"
    />
  </b-form-group>

   <b-form-group
    v-else-if="filter.type.toLowerCase() == 'bselect'"
    :label="filter.label"
    :label-for="filter.id"
  >
    <b-form-select
      v-model="filter.value"
      :input-id="filter.id"
      :options="filter.options"
      @input="setSelected"
      placeholder="กรุณาเลือกข้อมูล"
    />
  </b-form-group>

  <b-form-group
    v-else-if="filter.type.toLowerCase() === 'date'"
    :label="filter.label"
    :label-for="filter.id"
  >
    <!-- <datepicker
          :id="filter.id"
          :language="languages"
          format="dd/MM/yyyy"
          clearButton="true"
          :inputClass="'form-control '+filter.class"
        ></datepicker> -->
    <b-form-datepicker
      :id="filter.id"
      v-model="filter.value"
      v-bind="languages || {}"
      :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
      locale="th"
      :hide-header="false"
      today-button
      reset-button
      close-button
    />
  </b-form-group>
  <b-form-group
    v-else-if="filter.type.toLowerCase() === 'time'"
    :label="filter.label"
    :label-for="filter.id"
  >
    <b-form-timepicker
      :id="filter.id"
      v-model="filter.value"
      :hide-header="false"
      :hour12="false"
      now-button
      reset-button
      show-seconds
      label-close-button="ปิด"
      label-now-button="เวลาปัจจุบัน"
      label-reset-button="ล้าง"
      label-no-time-selected="กรุณาระบุเวลา"
    />
  </b-form-group>
  <b-form-group
    v-else
    :label="filter.label"
    :label-for="filter.id"
  >
    <b-form-input
      :id="filter.id"
      v-model="filter.value"
      :class="filter.class"
      :type="filter.type"
      :placeholder="filter.placeholder"
      @b-form-input="handleInput"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup, BFormInput, BFormDatepicker, BFormTimepicker, BFormSelect,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale'

export default {
  components: {
    BFormGroup,
    BFormInput,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
    BFormSelect,
    // Datepicker,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
  },
  //  beforeMount(){
  //   console.log("filter:",this.filter)
  // },
  data() {
    return {
      content: this.filter.value,
      languages: lang.th,
    }
  },
  methods: {
    handleInput(e) {
      this.$emit('b-form-input', this.content)
    },
    setSelected()
    {        
        this.$emit('select-input', this.filter)
    }
  },
}
</script>
 <style lang="scss" >
  .vdp-datepicker input:read-only{
    background-color: #fff;
  }
</style>
